var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KioskAuthLayout",
    {
      attrs: {
        "is-new": false,
        title: _vm.title,
        "show-next-button": _vm.phoneValid,
        "next-disabled": _vm.disableNextBtn,
        "show-back-button": ""
      },
      on: { back: _vm.handleBack, next: _vm.handleNext }
    },
    [
      _c(
        "div",
        { class: _vm.$style.numberLookup },
        [
          _c("p", { class: _vm.$style.numberLookupText }, [
            _vm._v(_vm._s(_vm.message))
          ]),
          _vm._v(" "),
          _c("Phone", {
            attrs: { error: _vm.error, disabled: _vm.disableNextBtn },
            model: {
              value: _vm.$v.phone.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.phone, "$model", $$v)
              },
              expression: "$v.phone.$model"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style.moreBtnWrapper },
            [
              _c(
                "BaseButton",
                {
                  class: _vm.$style.moreBtn,
                  attrs: { "button-style": "Back" },
                  on: { click: _vm.handleButtonClick }
                },
                [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")]
              ),
              _vm._v(" "),
              _vm.savingPage
                ? _c(
                    "a",
                    {
                      class: _vm.$style.moreLink,
                      on: { click: _vm.handleLearnMore }
                    },
                    [_vm._v("\n        Learn More")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/KioskNumberLookup.vue?vue&type=template&id=2c58e82d&
// module id = null
// module chunks = 